<template>
    <div class="row">
        <div class="col-12 col-md-7">

            <div class="row ">
                <div class="s-lbl col-12">Gib eine persönliche Widmung ein:</div>
                <div class="s-lbl col-12 mb-4">
                    <div class="textarea-wrap">
                        <textarea v-model="model.text"  maxlength="300" placeholder="max. 300 Zeichen" ></textarea>
                    </div>
                </div>

                <div class="s-lbl mt-4 col-12">Wähle deinen Lieblingsspieler:</div>
                <div class="d-flex star-container">


                <div class="star" v-on:click="player('hierlaender')"  v-bind:class="{selected: model.player === 'hierlaender'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/hierlaender.png">
                    </div>
                    <div class="star-lbl">
                        Stefan Hierländer
                    </div>
                </div>
                <div class="star" v-on:click="player('Scherpen')"  v-bind:class="{selected: model.player === 'Scherpen'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/scherpen.png">
                    </div>
                    <div class="star-lbl">
                        Kjell Scherpen
                    </div>
                </div>

                <div class="star" v-on:click="player('Biereth')"  v-bind:class="{selected: model.player === 'Biereth'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/biereth.png">
                    </div>
                    <div class="star-lbl">
                        Mika Biereth
                    </div>
                </div>
                <div class="star" v-on:click="player('Stankovic')"  v-bind:class="{selected: model.player === 'Stankovic'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/stankovic.png">
                    </div>
                    <div class="star-lbl">
                        Jon Gorenc Stankovič
                    </div>
                </div>
                <div class="star" v-on:click="player('Bovi')"  v-bind:class="{selected: model.player === 'Bovi'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/bovi.png">
                    </div>
                    <div class="star-lbl">
                        William Böving
                    </div>
                </div>
                <div class="star" v-on:click="player('Wueth')"  v-bind:class="{selected: model.player === 'Wueth'}">
                    <div class="star-picture">
                        <img src="/slides/child-slides/players/wueth.png">
                    </div>
                    <div class="star-lbl">
                        Gregory Wüthrich
                    </div>
                </div>
                </div>

            </div>
            <div class="d-flex nav-buttons">
                <div class="row mr-4">
                    <div class="s-nav">
                        <router-link to="Two" class="back-btn">ZURÜCK</router-link>
                    </div>
                </div>
                <div class="row steps-wrapper">
                    <div class="steps-info">
                        Schritt 2 von 3
                    </div>
                </div>
                <div class="row">
                    <div class="s-nav">
                        <router-link to="Five">WEITER ></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-5">
            <div class="cover-holder">
                <img src="/slides/child-slides/site-2.jpg">
                <div class="cover-layer cover-player-img">
                    <img  v-bind:src="'/slides/child-slides/players/'+model.player+'.png'"   />
                </div>
                <div class="cover-layer-text cover-name">
                    <span>{{model.text}}</span>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
// @ is an alias to /src


import store from '@/store/store.js'


export default {

    name: 'step-three',
    components: {

    },
    data() {
        return {
            model: store.three,
            preModel: store.one,
            headImg: 'Afro',
            glassImg: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            headCounter: 0,
            checked: false,
            validate: false,
            inputErrors: [],
            heads: ['Afro','Bob','Kurz glatt','Kurz lockig', 'Lang glatt', 'Lang wellig', 'Schulterlang wellig', 'Seiten kurz','Zopf lang glatt','Zopf lockig'],
        }
    },
    watch: {

        model: {
            deep: true,
            handler() {

            }
        }
    },
    methods: {
        player(pl) {
            this.model.player = pl;
        },


    }
}
</script>

<style scoped>
.cover-holder {
    overflow: hidden;
}

.cover-layer.cover-player-img {
    top: 172px;
    left: 250px;
}

.cover-holder img {
    border: 1px solid #000;
}

.cover-layer img {
    width: 100px;
    border: none;
    bottom: 1px;
}
    .cover-layer-text {
        font-size: 12px;
        top: 188px;
        left: 124px;
    }

    .cover-layer-text.name-2 {
        left: 212px;
    }

    .cover-layer-text.name-3 {
        left: 254px;
    }

    .cover-layer-text.name-4 {
        left: 278px;
    }



    .cover-layer-text span {
        width: 120px;
        text-align: center;
    }

    .cover-holder-3 .cover-layer-text span {
        width: 80px;
    }

    .cover-holder-4 .cover-layer-text span {
        width: 60px;
    }

    .cover-holder-3 .cover-layer-text.name-2 {
        left: 167px;
    }

    .cover-holder-4 .cover-layer-text.name-2 {
        left: 145px;
    }

    .cover-holder-4 .cover-layer-text.name-3 {
        left: 213px;
    }

.star-container {
    justify-content: space-between;
    flex-wrap: wrap;
}

.star {
    border: solid 1px transparent;
}

.star.selected {
    border: solid 1px black;
}

.star-picture {
    /* height: 200px;
    border: black 1px solid; */
    padding: 0 10px;
}

.star-picture img {
    width: 130px;
    height: auto;
}




</style>
